import React from 'react';
import { SignatureWidget, Checkbox } from 'ui';
import { Controller, useFormContext } from 'react-hook-form';

export const ActionModalContent = () => {
	const { control, register } = useFormContext();

	return (
		<>
			<div className="w-[100%]">
				<Controller
					name="signature"
					control={control}
					rules={{ required: true }}
					render={({ field }) => (
						<SignatureWidget
							onChange={(signature) => field.onChange(signature)}
							useManualSignature
							className="min-h-40"
						/>
					)}
				/>
			</div>
			<div className="mb-4 text-sm mt-4">
				<h4 className="font-semibold mb-2">Terms & Conditions</h4>
				<p className="text-muted-foreground pb-2">
					This estimate is not guaranteed. The price named above is an
					approximation based on the project requirements defined in conjunction
					with Ronald D. Hess. The actual cost may change after all elements of
					the project are negotiated and finalized...
				</p>

				<Checkbox
					label="I agree to the terms & conditions"
					// eslint-disable-next-line react/jsx-props-no-spreading
					{...register('termsAccepted', { required: true })}
				/>
			</div>
		</>
	);
};
